import { getDateInFormat } from "@domains/utils/reportDates";
export function ScripDetailMapper(data) {
    const limit = 5;
    const result = {
        events: data && data.events ? eventMapper(data.events) : {},
        news: data && data.news ? newsMapper(data.news, limit) : {},
        quote: data && data.quote ? quoteMapper(data.quote) : {},
        researchCall: data && data.rschCall ? researchCallMapper(data.rschCall, limit) : {},
    };
    return result;
}
const eventMapper = (event) => {
    return {
        displayName: event.dpName,
        resultList: event.resLst.map((res) => {
            return {
                date: getDateInFormat(res.date, "DD-MMM-YY"),
                event: res.event,
                value: res.val.includes(":") ? `Ratio ${res.val}` : `₹ ${res.val}`,
            };
        }),
    };
};
const newsMapper = (news, limit) => {
    news.content = news.content.slice(0, limit);
    return {
        first: news.first,
        last: news.last,
        number: news.number,
        size: news.size,
        symbol: news.symbol,
        totalElements: news.totalElements,
        totalPages: news.totalPages,
        date: news.content
            ? getDateInFormat(news.content[0].date, "DD-MMM-YY")
            : "",
        content: news.content.map((content) => {
            return {
                category: content.category,
                date: getDateInFormat(content.date, "DD-MMM-YY"),
                description: content.desc,
                guid: content.guid,
                title: content.title,
                customElements: {
                    displayName: content.customElements.dpName,
                    highlightedText: content.customElements.hghlTxt,
                    symbol: content.customElements.sym,
                    tradeSymbol: content.customElements.trdSym,
                },
            };
        }),
    };
};
const quoteMapper = (quote) => {
    return {
        research: quote.rchSt,
        marketDepth: {
            buyQty: quote.mkd.buyQty,
            sellQty: quote.mkd.sellQty,
            ask: quoteAskAndBidMaping(quote.mkd.ask),
            bid: quoteAskAndBidMaping(quote.mkd.bid),
            tableData: quoteTableMapping(quote.mkd.bid, quote.mkd.ask),
        },
        quoteObj: {
            close: quote.qt.c,
            low: quote.qt.l,
            open: quote.qt.o,
            high: quote.qt.h,
        },
    };
};
const researchCallMapper = (data, limit) => {
    data.lst = data.lst.slice(0, limit);
    return {
        currentSize: data.curSz,
        latestSize: data.lstSz,
        list: data.lst.map((item) => {
            return {
                entryPrice: item.entryPrc,
                returnFromRC: item.rt,
                startDate: getDateInFormat(item.stDt, "DD-MMM-YY"),
                targetPriceOne: item.tgtPrc1,
                act: {
                    action: item.act.act,
                    displayAction: item.act.dpAct,
                    sentiment: item.act.sntmnt,
                },
            };
        }),
    };
};
const quoteAskAndBidMaping = (list) => {
    return list.map((item) => {
        return {
            orders: item.no,
            price: item.price,
            quantity: item.qty,
        };
    });
};
const quoteTableMapping = (bid, ask) => {
    const resultArr = [];
    const total = {
        bidOrderTotal: 0,
        bidQtyTotal: 0,
        askOrderTotal: 0,
        askQtyTotal: 0,
    };
    bid.forEach((item, i) => {
        total.bidOrderTotal += parseInt(item.no);
        total.bidQtyTotal += parseInt(item.qty);
        total.askOrderTotal += parseInt(ask[i].no);
        total.askQtyTotal += parseInt(ask[i].qty);
        let mixup = {
            bidPrice: item.price,
            bidOrder: item.no,
            bidQuantity: item.qty,
            askPrice: ask[i].price,
            askOrder: ask[i].no,
            askQuantity: ask[i].qty,
        };
        resultArr.push(mixup);
    });
    return { data: resultArr, total: total };
};
